<script>
import AccountantConnectionService from "@/store/services/accountants.service.js";
import TotalAmountsBase from "@/components/base_components/TotalAmountsBase.vue";

export default {
  name: "TotalAmountsAccountants",
  extends: TotalAmountsBase,
  data() {
    return {
      mutationName: 'filterStore/SET_UPDATE_FILTER_ACCOUNTANTS'
    }
  },
  methods: {
    getTotalAmounts(){
      if(Object.keys(this.filters).length !== 0){
        this.loading = true
        if(!this.filters.owner_company){
          this.filters.owner_company = window.company_id;
        }
        let promises = []
        promises.push(AccountantConnectionService.getPendingInvites(this.filters))
        promises.push(AccountantConnectionService.getAccountantConnectionsV3(this.filters))
        Promise.all(promises).then((responses) => {
            this.loading = false
            this.amountsList = [];
            let connected = responses[1].data.results.filter(connection => connection.status === "connected").length;
            let disconnected = responses[1].data.results.filter(connection => connection.status === "disconnected").length;
            this.amountsList.push({text: this.$gettext("PENDING"), amount: responses[0].data.length, class:'text-brand'});
            this.amountsList.push({text: this.$gettext("DISCONNECTED"), amount: disconnected, class:'text-blue'});
            this.amountsList.push({text: this.$gettext("CONNECTED"), amount: connected, class:''});
        })
      }
    }
  }
};
</script>